import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Fade from 'react-reveal/Fade';

import { ThemeContext } from '../../contexts/ThemeContext';

import './Achievement.css'

function AchievementCard({id, title, details, date, field}) {

    const { theme } = useContext(ThemeContext);

    const useStyles = makeStyles((t) => ({
        achievementCard : {
            backgroundColor:theme.primary30,
            "&:hover": {
                backgroundColor:theme.primary50,
            },
        },
    }));

    const classes = useStyles();
    return (
        <Fade bottom>
           <div key={id} className={`achievement-card ${classes.achievementCard}`}>
               <div className="achievecard-content">
                    <div className="achievecard-details1">
                        <h2 style={{color: theme.tertiary}}>{title}</h2>
                        <p style={{color: theme.tertiary80}}>{details}</p>
                    </div>
                    {(date || field) ? (
                    <div className="achievecard-details2" style={{color: theme.primary}}>
                        {date ? <h5>{date}</h5> : null}
                        <div className="achievecard-field">
                            {field ? <h5>{field}</h5> : null}
                        </div>   
                    </div>
                    ) : null}
                </div> 
                <div
                    className="achievecard-badge"
                    style={{
                        borderColor: theme.primary,
                        color: theme.primary,
                    }}
                >
                    Certified
                </div>
           </div>
        </Fade>
        
    )
}

export default AchievementCard
